export default "__VITE_ASSET__BwElS$A8__"